import React from 'react';
import { Route } from 'react-router-dom';
import SimpleStepSection from '../pages/simple-steps/SimpleStepSection';
import SimpleStepItems from '../pages/simple-steps/SimpleStepItems';
import CreateSimpleStepItem from '../pages/simple-steps/CreateSimpleStepItem';
import EditSimpleStepItem from '../pages/simple-steps/EditSimpleStepItem';
import ProtectedRoute from '../components/global/ProtectedRoute';

const simpleStepsRoutes = (
    <>
        <Route
            path="/simple-steps/section"
            element={
                <ProtectedRoute requiredPermission="viewAny-simple-step-section">
                    <SimpleStepSection />
                </ProtectedRoute>
            }
        />

        <Route
            path="/simple-steps"
            element={
                <ProtectedRoute requiredPermission="viewAny-simple-step-item">
                    <SimpleStepItems />
                </ProtectedRoute>
            }
        />

        <Route
            path="/simple-steps/create"
            element={
                <ProtectedRoute requiredPermission="create-simple-step-item">
                    <CreateSimpleStepItem />
                </ProtectedRoute>
            }
        />

        <Route
            path="/simple-steps/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-simple-step-item">
                    <EditSimpleStepItem />
                </ProtectedRoute>
            }
        />
    </>
);

export default simpleStepsRoutes;
